import { render, staticRenderFns } from "./HSCodeDropdownField.vue?vue&type=template&id=0f20a543&scoped=true"
import script from "./HSCodeDropdownField.vue?vue&type=script&lang=js"
export * from "./HSCodeDropdownField.vue?vue&type=script&lang=js"
import style0 from "./HSCodeDropdownField.vue?vue&type=style&index=0&id=0f20a543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20a543",
  null
  
)

export default component.exports